import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud/services/workspace-server';
import { WorkspaceScope } from '../workspace/scopes/workspace';
import { WorkspaceService } from '../workspace/services/workspace';
import { OfflineMutationOutboxService } from './services/offline-mutation-outbox';
import { WorkspaceBlobUploadOutboxService } from './services/workspace-blob-upload-outbox';

export {
  IndexedDBOfflineMutationOutboxStorage,
  MemoryOfflineMutationOutboxStorage,
  OfflineMutationDomainError,
  OfflineMutationOutboxService,
  OfflineMutationTransientError,
} from './services/offline-mutation-outbox';
export {
  type StageWorkspaceBlobOptions,
  WorkspaceBlobUploadOutboxService,
} from './services/workspace-blob-upload-outbox';
export type {
  BlobUploadMutationPayload,
  CalendarAttachSourceMutationPayload,
  CalendarCreateMailboxLinkMutationPayload,
  CalendarCreateSourceMutationPayload,
  CalendarDeleteMailboxLinkMutationPayload,
  CalendarSourceRefMutationPayload,
  CalendarUpdateMailboxLinkMutationPayload,
  CalendarUpdateSourcePreferenceMutationPayload,
  FolderAddDocMutationPayload,
  FolderCreateMutationPayload,
  FolderRemoveDocMutationPayload,
  FolderRenameMutationPayload,
  MailCreateFolderMutationPayload,
  MailDeleteFolderMutationPayload,
  MailMoveMessagesMutationPayload,
  MailSendMutationPayload,
  MailUpdateFolderMutationPayload,
  MailUpdateMessageStateMutationPayload,
  OfflineMutationExecutor,
  OfflineMutationInput,
  OfflineMutationOperation,
  OfflineMutationOutboxStorage,
  OfflineMutationPayload,
  OfflineMutationPayloadByOperation,
  OfflineMutationRecord,
  OfflineMutationScope,
  OfflineMutationStatus,
  ViewBackedAppAttachSourceMutationPayload,
  ViewBackedAppCreateSourceMutationPayload,
  ViewBackedAppSourceRefMutationPayload,
  ViewBackedAppUpdateSourcePreferenceMutationPayload,
} from './types';

export function configureOfflineMutationOutboxModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(OfflineMutationOutboxService, [
      WorkspaceService,
      WorkspaceServerService,
    ])
    .service(WorkspaceBlobUploadOutboxService, [
      WorkspaceService,
      WorkspaceServerService,
      OfflineMutationOutboxService,
    ]);
}
